import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input, OnDestroy } from '@angular/core';
import { UserConnectionService } from '@app/shared/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConnectRelationshipDialogComponent } from '@app/shared/component/connect-relationship-dialog/connect-relationship-dialog.component';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'underscore';
import { UserInviteComponent } from '@app/shared/component/user-invite/user-invite.component';
import { Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as loginSelectors from '../../../root-store/login-store/login.selector';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'suggestion',
  templateUrl: './suggestion.component.html',
  styleUrls: ['./suggestion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestionComponent implements OnInit, OnDestroy {
  url: string;
  user: any = {};
  suggestionsData: Array<any> = [];
  viewData: Array<any> = [];
  allSuggestionsData: Array<any> = [];
  suggestionPageSize = 10;
  suggestionPageCurrentIndex = 1;
  suggestionPages: Array<{ pageIndex: number; pageStart: number; pageEnd: number }> = [];
  @Input('compactView') compactView: boolean = false;
  @Input('miniView') miniView: boolean = false;
  @Input('suggestionsLimit') suggestionLimit: number = 0;
  @Input('hideMiniShowAll') hideMiniShowAll: boolean = false;
  subscription = new Subscription();

  constructor(
    private userConnectionService: UserConnectionService,
    private cd: ChangeDetectorRef,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private _store: Store
  ) {}
  ngOnInit() {
    if (this.miniView) {
      this.compactView = true;
    }

    //ensure that page is scrolled to the
    window.scroll(0, 0);
    // get user all details
    this.subscription.add(
      this._store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.user = result;
          this.suggestions();
        } else {
          this.user = null;
        }
      })
    );
  }

  suggestions() {
    this.subscription.add(
      this.userConnectionService.getSuggestions({}).subscribe(
        (data: any) => {
          this.allSuggestionsData = data.suggestions;
          this.setupSuggestionPages();
          this.suggestionsData = this.allSuggestionsData.slice(0, this.suggestionLimit > 0 ? this.suggestionLimit : this.suggestionPageSize);
          this.cd.markForCheck();
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  openConnectModal(params) {
    //since this is a suggestion it will have a connection id, so clear it out so the connection dialog knows this is a new connection
    delete params.connection_id;

    this.viewData['user'] = params;
    const modalRef = this.modalService.open(ConnectRelationshipDialogComponent);
    modalRef.componentInstance.data = this.viewData;
    modalRef.result
      .then((result) => {
        this.suggestions();
      })
      .catch((error: any) => {});

    return false;
  }

  openInviteDialog() {
    this.modalService.open(UserInviteComponent);
  }

  changePage(destPage) {
    if (destPage == 'pre') {
      //go to previous page
      destPage = this.suggestionPageCurrentIndex - 1;
    } else if (destPage == 'next') {
      //go to next page
      destPage = this.suggestionPageCurrentIndex + 1;
    }

    let page = this.suggestionPages.filter((page) => page.pageIndex.toString() == destPage)[0];
    this.suggestionsData = this.allSuggestionsData.slice(page.pageStart, page.pageEnd);
    this.suggestionPageCurrentIndex = destPage;
  }

  private setupSuggestionPages() {
    this.suggestionPageCurrentIndex = 1;
    this.suggestionPages = [];
    //build pages for pagination
    for (let i = 1; i <= this.allSuggestionsData.length / this.suggestionPageSize + 1; i++) {
      let startingIndex = i * this.suggestionPageSize;

      if (startingIndex - this.suggestionPageSize >= this.allSuggestionsData.length) return; //we have just enough records to fill one last page, do not include the final page.

      this.suggestionPages.push({ pageIndex: i, pageStart: startingIndex - this.suggestionPageSize, pageEnd: startingIndex });
    }
  }

  ignoreSuggestion(suggested_user_id) {
    this.subscription.add(
      this.userConnectionService.ignoreSuggestion(suggested_user_id).subscribe((results) => {
        this.suggestions();
      })
    );

    return false;
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
